import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import {
  GroupParticipantsResource,
  ParticipantResource,
} from '../../../../../GroupParticipantsStore/Types';
import RemoveParticipantStore from './RemoveParticipantStore/Store';

export interface Props {
  store: RemoveParticipantStore;
  participant: ParticipantResource;
  groupParticipantsResource: GroupParticipantsResource;
}

function RemoveParticipant({ store, participant, groupParticipantsResource }: Props) {
  return (
    <div
      className="cursor-pointer"
      onClick={() => store.ready(participant, groupParticipantsResource)}
    >
      <T kind="Remove participant" />
    </div>
  );
}

export default observer(RemoveParticipant);
